import React from 'react'
import { CSSObject } from 'styled-components'
import * as S from './styled'

interface Props {
    width?: string
    filter: string
    setFilter: (term: string) => void
}

const SearchBar: React.FC<Props> = ({ width, filter, setFilter }) => {
    return <S.SearchBar width={width} filter={filter} setFilter={setFilter} />
}

export default SearchBar
